import { html, ViewTemplate } from '@microsoft/fast-element';
import { getFormattedNumber } from '../../../../utils/formatting';
import type { NegotiationTile } from './negotiation-tile';

export const NegotiationTileTemplate: ViewTemplate<NegotiationTile> = html`
  <div
    class="negotiation
            ${(x) => x.formatStatus()} 
            ${(x) => x.negotiation.TECHNOLOGY.toLowerCase()} 
            ${(x) =>
      x.negotiation.NEGOTIATION_ID === x.structuredChatService.selectedNegotiationID
        ? 'selected'
        : ''}"
    @click=${(x) => x.negotiationSelected()}
  >
    <div class="technology-icon">${(x) => x.getTechnologyIcon()}</div>
    <div class="header">${(x) => x.getCounterPartyCompany()}</div>
    <div>${(x) => x.negotiation.VPPA_TICKER}(${(x) => x.negotiation.VPPA_UNIQUE_ID})</div>
    <div>
      ${(x) => x.negotiation.ISO} - $${(x) => x.negotiation.FIXED_PRICE} MW/h -
      ${(x) => getFormattedNumber(x.negotiation.OFFERED_CAPACITY)}MW
    </div>
  </div>
`;
